import React, { useState, useEffect } from 'react';
import THEME from '../utils/theme';
import { FaBars, FaTimes } from 'react-icons/fa';

const NAV_LINKS = [
  { href: '#courses', label: 'Courses'         },
  { href: '#batches', label: 'Batches'         },
  { href: '#stories', label: 'Success Stories' },
  { href: '#notices', label: 'Notices'         },
  { href: '#videos',  label: 'Videos'          },
];

export default function Navbar() {
  const [scrolled, setScrolled]   = useState(false);
  const [menuOpen, setMenuOpen]   = useState(false);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
      background: scrolled ? 'rgba(255,248,244,0.96)' : 'transparent',
      backdropFilter: scrolled ? 'blur(12px)' : 'none',
      borderBottom: scrolled ? `1px solid ${THEME.red}20` : 'none',
      padding: '0 clamp(20px,4vw,40px)',
      transition: 'all 0.35s ease',
    }}>
      <div style={{
        maxWidth: 1200, margin: '0 auto',
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between', height: 72,
      }}>
        {/* Logo */}
        <a href="#hero" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 12 }}>
          <div>
            <img src="/logo.png" alt="logo" style={{
              width: '12vw', minWidth: '60px', maxWidth: '180px',
              height: 'auto', objectFit: 'contain', display: 'block',
            }} />
          </div>
        </a>

        {/* Desktop links */}
        <div className="sk-desktop-nav" style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
          {NAV_LINKS.map(l => (
            <a key={l.href} href={l.href} style={{
              textDecoration: 'none',
              color: scrolled ? THEME.navy : 'rgba(255,255,255,0.85)',
              fontSize: 14, fontWeight: 500, padding: '8px 14px', borderRadius: 4,
              transition: 'color 0.2s, background 0.2s',
            }}
              onMouseEnter={e => { e.target.style.color = THEME.red; e.target.style.background = THEME.redLight; }}
              onMouseLeave={e => { e.target.style.color = scrolled ? THEME.navy : 'rgba(255,255,255,0.85)'; e.target.style.background = 'transparent'; }}>
              {l.label}
            </a>
          ))}
          <a href="#apply" style={{
            background: THEME.red, color: 'white', border: 'none',
            padding: '10px 22px', borderRadius: 4,
            fontFamily: "'Syne', sans-serif", fontWeight: 700, fontSize: 13,
            textDecoration: 'none', marginLeft: 8, letterSpacing: '0.04em',
            transition: 'background 0.2s',
          }}
            onMouseEnter={e => e.currentTarget.style.background = THEME.redDark}
            onMouseLeave={e => e.currentTarget.style.background = THEME.red}>
            Apply Now
          </a>
        </div>

        {/* Hamburger */}
        <button className="sk-hamburger" onClick={() => setMenuOpen(o => !o)} style={{
          display: 'none', background: 'none', border: 'none',
          cursor: 'pointer', padding: 8,
          color: scrolled ? THEME.navy : 'white',
        }}>
          {menuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
        </button>
      </div>

      {/* Mobile drawer */}
      {menuOpen && (
        <div style={{
          background: 'white', padding: '16px 24px 28px',
          borderTop: `1px solid ${THEME.red}20`,
          boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
        }}>
          {NAV_LINKS.map(l => (
            <a key={l.href} href={l.href} onClick={() => setMenuOpen(false)} style={{
              display: 'block', textDecoration: 'none',
              color: THEME.navy, fontSize: 16, fontWeight: 500,
              padding: '13px 0', borderBottom: `1px solid ${THEME.sand}`,
            }}>{l.label}</a>
          ))}
          <a href="#apply" onClick={() => setMenuOpen(false)} style={{
            display: 'block', textAlign: 'center',
            background: THEME.red, color: 'white',
            padding: '13px', borderRadius: 6, marginTop: 16,
            fontFamily: "'Syne', sans-serif", fontWeight: 700,
            fontSize: 15, textDecoration: 'none',
          }}>Apply Now</a>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .sk-desktop-nav { display: none !important; }
          .sk-hamburger    { display: block !important; }
        }
      `}</style>
    </nav>
  );
}
